import React from 'react';
import { getPlatformAssetUrl } from '../utils/api';
import { DEFAULT_FOOTER_TAGLINE } from '../context/PlatformBrandingContext';

export default function AppFooter({ platformBranding = null, className = '' }) {
  const platformLogoUrl = getPlatformAssetUrl(
    platformBranding?.logo,
    platformBranding?.version
  );
  const footerLogoSrc = platformLogoUrl
    || `${process.env.PUBLIC_URL || ''}/images/school-analytics-footer-logo.png`;
  const footerAlt = platformBranding?.name
    || 'School Analytics CPRawat — Smart insights. Better education.';
  const tagline = platformBranding?.footer_tagline || DEFAULT_FOOTER_TAGLINE;

  const footerClassName = className
    || 'mt-6 border-t border-border py-4 px-4 lg:px-8';

  return (
    <footer className={footerClassName}>
      <div className="flex flex-col items-center gap-2 text-center">
        <img
          src={footerLogoSrc}
          alt={footerAlt}
          className="h-12 w-auto max-w-[min(320px,90vw)] object-contain"
        />
        <p className="text-xs text-muted-foreground">{tagline}</p>
      </div>
    </footer>
  );
}
